// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'


export const getAllDataGroups = createAsyncThunk('appUsers/getAllDataGroups', async () => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/groups/all')
  return response.data
})

export const getDataGroups = createAsyncThunk('appUsers/getDataGroups', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/groups/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})
export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addGroup = createAsyncThunk('appUsers/addGroup', async (group, { dispatch, getState }) => {
  await axios.post('https://apiv3.opentlv.com/api/v3/users/groups/addgroup', group)

  await dispatch(getDataGroups(getState().groups.params))
//  await dispatch(getAllData())
  return user
})

export const deleteGroup = createAsyncThunk('appUsers/deleteGroup', async (id, { dispatch, getState }) => {
  await axios.delete('https://apiv3.opentlv.com/api/v3/users/groups/delete', {params: {id}})
  console.log(getState())
  await dispatch(getDataGroups(getState().groups.params))
  //await dispatch(getDataGroups())
  return id
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataGroups.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataGroups.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appUsersSlice.reducer
